import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { DashboardUsersShelvesModel } from '~/model/model.dashboard.users.shelves';
import { UIService } from '~/service/service.ui';
import { useModel, useService } from '~/shared/service/service.base';
import { GridNoRows } from '../grid/grid.norows';
import { AsyncView } from '../view.async';

export const DashboardUsersShelvesDialog = observer(() => {
	const [ui] = useService(UIService);
	const model = useModel(DashboardUsersShelvesModel);
	const open = ui.dialog === DashboardUsersShelvesDialog;

	useEffect(() => {
		if (open) model.fetchData();
	}, [model, open]);

	return (
		<Dialog open={open} fullWidth maxWidth="sm" onClose={ui.hideDialog}>
			<DialogTitle>Top users by number of fragrances on shelves</DialogTitle>
			<DialogContent>
				<AsyncView async={model.async}>
					<List sx={{ height: '50vh' }}>
						<Virtuoso
							data={model.items}
							itemContent={(_, item) => (
								<ListItem key={item.id} dense>
									<ListItemAvatar>
										<Avatar variant="circular" src={item.avatars?.at(0)} />
									</ListItemAvatar>
									<ListItemText primary={item.nickName} secondary={item.count} />
								</ListItem>
							)}
							components={{
								EmptyPlaceholder: () => <GridNoRows>No users</GridNoRows>,
							}}
						/>
					</List>
				</AsyncView>
			</DialogContent>
			<DialogActions>
				<Button onClick={ui.hideDialog}>Close</Button>
			</DialogActions>
		</Dialog>
	);
});
